<template>
  <div class="CreatePropsFromSearchedComponent DataTables">
    <span v-if="!isAll">
    <p>{{lang.infotext_1}}:</p>
    
      <div v-show="!isData">
        <LoaderComponent  v-if="!isData"></LoaderComponent>
      </div>
      <div v-show="isData" :id="id"></div>
    </span>

 </div>
</template>

<script>
import LoaderComponent from "@/components/shared/LoaderComponent"

export default {
  name: 'CreatePropsFromSearchedComponent',
  props:{
    lang: Object
  },
  components: {

    LoaderComponent
  },
  data () {
    return {
      mainTable: "",
      id: "CreatePropsFromSearchedComponent",
      foundPartDatas: [],
      fullListPropsFound: [],
      types: [],
      newProperties: [
        {id: 0, name: "", value: "", found: ""}
      ],
      propCounter: 0
    }
  },
  computed: {
    isAll(){
      if (this.$store.getters.selectedTreeItemObject.category == "All components"){
        return true;
      }
      return false;
    },
    isData(){
      return this.fullListPropsFound.length != 0;
    },
    categoryId(){
      return this.$store.getters.selectedTreeItemObject.categoryId;
    },
    categoryName(){
      return this.$store.getters.selectedTreeItemObject.category;
    },
    selectedSearchedRows(){
      return this.$store.getters.selectedSearchedRows;
    },

  },
  created () {
    this.getTypes();
    this.getDataDetails();
  },
  watch: {
    categoryId: function(newVal, oldVal){

      this.getDataDetails();
    },
    newProperties: {
      handler: function(newVal, oldVal){
        
        const tab = [...this.newProperties];
        tab.splice(tab.length - 1, 1);
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_setDerivedNewProps", tab);
      },
      deep: true
    }
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    getTypes(){
      let vue = this;

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPropertiesType")
      .then(function(result) {
        console.log("_getPropertiesType")
        console.log(result)

        if (result.status == "OK"){

          vue.types = result.data;


        }

      })
    },
    getDataDetails(){

      let vue = this;

      const obj = {
        distributorPartId: this.selectedSearchedRows.DistributorPartId

      }

      let payload = this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchedPartsDetails", obj)
      .then(function(result) {
        console.log("_getSearchedPartsDetails")
        console.log(result)

        if (result.status == "OK"){

          vue.foundPartDatas = result.data;



          vue.buildFullPropsListFound();
        }

      })

    },
    buildFullPropsListFound(){
      
      this.propCounter = 0;
      for (let el in this.selectedSearchedRows) {
        let s = this.selectedSearchedRows[el];
        if (s == null) {
          s = "";
        } else {

        }
        const obj = {
          text: el + " -> " + s,
          value: el + "__^__" + s,
          id: this.propCounter
        }

        this.fullListPropsFound.push(obj);
        this.propCounter++;
      }

      for (let i = 0, lei = this.foundPartDatas.Properties.length; i < lei; i++){
        let value = "";
        if (this.foundPartDatas.Properties[i].Type == "singleValue"){

          if (this.foundPartDatas.Properties[i].Values != null){
            value = this.foundPartDatas.Properties[i].Values;
          }

        }else{
          try{
            value = this.foundPartDatas.Properties[i].Values[0];
          }catch(ex){
            console.log(ex);

          }

        }
        const obj = {
          text: this.foundPartDatas.Properties[i].Name + " -> " + value,
          value: this.foundPartDatas.Properties[i].Name + "__^__" + value,
          id: this.propCounter
        }

        this.fullListPropsFound.push(obj);
        this.propCounter++;
      }




      this.buildTable();

    },
    buildTable(){
      console.log("CreatePropsDerivePartFound")

      

      //todo reset array of defined

      var tableplace = document.getElementById(this.id);
      if (tableplace == null){
        return
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");

      var thead = document.createElement("thead");
      thead.appendChild(tr);

      table.appendChild(thead);

      let vue = this;


      let cols =  [

        { "data": "name" },
        { "data": "value" },
        { "data": "type" },
        { "data": "found" },
        
        
      ]

      let columns = [

        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Value,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Found,
          alignInColumn: "left",

        },
        
        


      ]




      var columnDefs = [];

      for (var i = 0, len = columns.length; i < len; i++){

        let classname = '_dt-body-'+ columns[i].alignInColumn;

        let  el = {
            targets: i,
            className: classname,
            render: function ( data, type, row, meta ) {
              if (data == null) {
                data = "";
              }

              data = $.fn.dataTable.render.text().display(data);
              if (data.display != undefined) {
                data.display = $.fn.dataTable.render.text().display(data.display);
              }

              if (meta.col == 0){
                let str = "";
                  str += "<div role=\"group\" class=\"input-group input-group-sm input-group-name\">";

                  str += "<input class=\"form-control input-name\" type=\"text\" id=\"name__" + row.id + "\" value=\"" + data + "\">";
                  str += "</div>";
                  return str;
              }

              if (meta.col == 1){

                  let str = "";
                  str += "<div role=\"group\" class=\"input-group input-group-sm\">";

                  str += "<input class=\"form-control input-value\" type=\"text\" id=\"value__" + row.id + "\" value=\"" + row.value + "\">";
                  str += "</div>";
                  return str;

              }
              if (meta.col == 2){
                let elem = "";
                elem += "<div class=\"select-group-type\">";
                elem += "<select id=\"type__" + row.id + "\" class=\"custom-select custom-select-sm select-type\">";
                
                for (let k = 0, lek = vue.types.length; k < lek; k++){

                  elem += "<option value=\"" + vue.types[k] + "\">" + vue.types[k] + "</option>";
                }

                elem += "</select>";
                elem += "</div>";
                return elem;
              }
              if (meta.col == 3){
                let trig = false;
                let elem = "";
                elem += "<div class=\"select-group\">";
                elem += "<select id=\"prop__" + row.id + "\" class=\"custom-select custom-select-sm select-prop\">";
                elem += "<option value=\"\"></option>";

                

                for (let k = 0, lek = vue.fullListPropsFound.length; k < lek; k++){
                  
                  let temp = vue.fullListPropsFound[k].value.split("__^__");

                  if (temp[0] == row.name){
                    trig = true;
                    break;
                  }else{
                    elem += "<option value=\"" + vue.fullListPropsFound[k].value + "\" >" + vue.fullListPropsFound[k].text + "</option>";
                  }
                  
                }

                elem += "</select>";
                elem += "</div>";
                if (trig){
                  elem = "<button  class=\"btn btn-secondary btn-sm button_action_delete\" id=\"button_delete_" + row.id +"\" >"+vue.lang.button_Delete+"</button>";
                }
                return elem;
              }
              
              

              return data;
            }
          }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        var br = document.createElement("br");
        th.appendChild(br);


        var tx = document.createTextNode(columns[i].name)
        th.appendChild(tx);


      }


      var option = {};
      option.paging = false;
      option.info = false;
      option.dom = 'f<t>';
      option.data= this.newProperties;
      option.myColumnFormats = columns;
      option.select = false;
      option.columns = cols;
      option.columnDefs = columnDefs;


      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          console.log("DESTROY TABLE")
      }



      this.mainTable = $('#t_'+this.id).DataTable(option);


      this.mainTable.columns.adjust().draw();

      //hide first column in table
      //this.mainTable.column( 0 ).visible( false );

      //search input change view
      var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }

      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

      
      
      let selectType = document.getElementsByClassName('select-type');

      for (var i = 0; i < selectType.length; i++) {
        selectType[i].addEventListener('change', function (e){

          
          let temp = this.id.split("__")
          console.log()
          for (let j = 0, lej = vue.newProperties.length; j < lej; j++){
            if (temp[1] == vue.newProperties[j].id){
              vue.newProperties[j].type = this.value;
              break;
            }

          }

        })
      }

      let selectProp = document.getElementsByClassName('select-prop');

      for (var i = 0; i < selectProp.length; i++) {
        selectProp[i].addEventListener('change', function (e){

          let temp = this.id.split("__");

          let val_name = this.value.split("__^__");

          let fieldName = document.getElementById("name__" + temp[1]);

          fieldName.value = val_name[0];

          let fieldValue = document.getElementById("value__" + temp[1]);

          fieldValue.value = val_name[1];
          
          let id = "";
          for (let j = 0, lej = vue.fullListPropsFound.length; j < lej; j++){
            let temp = vue.fullListPropsFound[j].value.split("__^__");

            if (temp[0] == val_name[0]){
              id = vue.fullListPropsFound[j].id;
              break;
            }
          }

          const obj = {
            id: id,
            value: val_name[1],
            name: val_name[0],
            type: "text"
          }


          let len = vue.newProperties.length;
          vue.newProperties.splice(len - 1, 0, obj);

          vue.buildTable();

        })
      }


      let buttons_action_delete = document.getElementsByClassName('button_action_delete');


      for (var i = 0; i < buttons_action_delete.length; i++) {
        buttons_action_delete[i].addEventListener('click', function (e){

          var tr = $(this).closest('tr');
          var row = vue.mainTable.row( tr );

          var data = row.data();

          
          for (let j = 0, lej = vue.newProperties.length; j < lej; j++){

            if (data.name == vue.newProperties[j].name){

              vue.newProperties.splice(j, 1);
              break;
            }
          }
          vue.buildTable();
        })
      }

      this.propCounter ++;

    },
  }
}
</script>


<style lang="scss">
  @import "./../../scss/_custom.scss";

  .CreatePropsFromSearchedComponent{
    #t_CreatePropsFromSearchedComponent{
      width: 100% !important;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      width: 100%;
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;
      margin-top: 4px;
    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    td{
      word-break: break-all;
    }
    .input-group{
      min-width: 400px;

    }
    .input-group-name{
      min-width: 300px;

    }
    .select-group{
      min-width: 400px;

    }
    .select-group-type{
      min-width: 120px;

    }
    .input-name{
      height: 31px !important;
    }
    .input-value{
      height: 31px !important;
    }
    .input-value{
      height: 31px;
    }
    .img-thumbnail{
      width: 100px;
    }
    .form-control{
      //height: 26.8px;
    }
    .option-grey{
      color: #999;
    }
    .input-name{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .input-value{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .select-type{
      margin-top: 3px;
      margin-bottom: 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/CreatePropsFromSearchedComponent.vue